import React from 'react';
import './Header.css'

const Header = () => {
  return <header>
    <a href={window.location.origin}>
      <h1>Eren's Dev Blog</h1>
    </a>
  </header>;
};

export default Header;
